/* eslint-disable no-nested-ternary */
import { ChangeEvent, useMemo, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import {
  Card,
} from '../../../components/Lists';
import InputSearch from '../../../components/InputSearch';
import { DataByWorkplaceType } from '../types';
import floatToCurrency from '../../../utils/floatToCurrency';
import OpacityAnimation from '../../../components/OpacityAnimation';

interface EmployeesListInterface {
  list: DataByWorkplaceType[];
}

export default function EmployeesList({
  list,
}: EmployeesListInterface) {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredFuncs = useMemo(() => list?.filter((func) => (
    func.name.toLowerCase().includes(searchTerm.toLowerCase())
    || func.cpf.toLowerCase().includes(searchTerm.toLowerCase())
  )), [list, searchTerm]);

  function handleChangeSearchTerm(event: ChangeEvent<HTMLInputElement>) {
    setSearchTerm(event.target.value);
  }

  return (
    <>
      <InputSearch
        searchTerm={searchTerm}
        handleChangeSearchTerm={handleChangeSearchTerm}
        placeholder="Pesquisar funcionário (nome / cpf)"
      />

      <Container style={{ marginTop: 24 }}>
        <Row xs={1} md={1} lg={2}>
          {filteredFuncs?.map((employee) => (
            <Col key={employee.cpf}>
              <OpacityAnimation delay={0.1}>
                <Card>
                  <div className="info">
                    <div className="card-title">
                      <strong>{employee.name}</strong>
                      <small>{floatToCurrency(employee.currentVT)}</small>
                    </div>
                    <span>
                      CPF:
                      {' '}
                      {employee.cpf}
                    </span>
                    {employee.minVT && (
                      <>
                        <span>
                        VT pode chegar até
                          {' '}
                          {floatToCurrency(employee.minVT)}
                        </span>
                        <span>
                        Economia de até
                          {' '}
                          {floatToCurrency(employee.currentVT - employee.minVT)}
                        </span>
                      </>
                    )}
                  </div>
                </Card>
              </OpacityAnimation>
            </Col>
          ))}
        </Row>
      </Container>
    </>
  );
}
